<template>
  <div class="page">
    <div
      v-for="section in pageData.sections"
      :key="section.title"
      class="page__component-container"
      v-bind:style="{
        backgroundColor: `var(--${section.backgroundColour})`
      }"
    >
      <page-hero v-if="section.type === 'homePage'" :data="section" class="container" />
      <multi-column v-if="section.type === 'multiColumn'" :data="section" class="container" />
      <full-width-text
        v-if="section.type === 'singleTextColumn'"
        :data="section"
        class="container"
      />
      <centred-full-width
        v-if="section.type === 'fullWidthSection'"
        :data="section"
        class="container"
      />
      <testimonial-section
        v-if="section.type === 'oneTestimonial'"
        :data="section"
        class="container"
      />
    </div>
  </div>
</template>

<script>
import PageHero from '@/components/PageHero.vue';
import MultiColumn from '@/components/MultiColumn.vue';
import FullWidthText from '@/components/FullWidthText.vue';
import CentredFullWidth from '@/components/CentredFullWidth.vue';
import TestimonialSection from '../components/TestimonialSection.vue';

export default {
  name: 'Home',
  props: ['pageName'],
  components: {
    CentredFullWidth,
    FullWidthText,
    PageHero,
    MultiColumn,
    TestimonialSection,
  },
  computed: {
    pageData() {
      return this.$store.state.pages.length
        ? this.$store.state.pages.find((page) => page.pageName === this.pageName)
        : [];
    },
  },
};
</script>

<style scoped>
.page {
  display: flex;
  flex-flow: wrap;
}

.page__component-container {
  width: 100%;
}
</style>
